import React from "react";
import { Link, Redirect } from "react-router-dom";

import Slider from "../SliderView/MainSlider";
import HomePageBanner from "./homePageBanner";
import Helper from "../Helper/helper";
import ExperienceGate from "../Experience/ExperienceGate";
import { t } from "react-multi-lang";
import HomeLoader from "../Loader/HomeLoader";
import { resolvePublicPageType, isKidsSectionEnabled } from "../Helper/siteContent";
import ContentCard from "../Content/ContentCard";

/**
 * Series / Movies / Kids / public-slug browse.
 * Same component is reused across routes — must reload only when resolved
 * page_type changes (not on every prop tick), or stale home_first_section
 * responses can paint the wrong page (Series↔Movies intermittent wrong-page).
 *
 * Second-section rows come from CategoryPageResolver (is_series / is_movies /
 * CATEGORY) via Content Items — ContentCard supports VMS videos + Scheduler channels.
 */
class Genres extends Helper {
    state = {
        maindata: null,
        errorHandle: 0,
        loading: true,
        banner: null,
        loadingHomeSecondSection: true,
        homeSecondData: null,
        page_type: null,
        experience: null,
    };

    resolveInputData(match) {
        const resolved = resolvePublicPageType(match);
        return {
            page_type: resolved.page_type,
        };
    }

    loadPage(match) {
        const inputData = this.resolveInputData(match);
        this.setState({
            loading: true,
            loadingHomeSecondSection: true,
            maindata: null,
            banner: null,
            homeSecondData: null,
            page_type: inputData.page_type,
            experience: null,
        });
        this.homeFirstSection(inputData);
    }

    componentDidMount() {
        this.loadPage(this.props.match);
    }

    componentDidUpdate(prevProps) {
        const prevType = resolvePublicPageType(prevProps.match).page_type;
        const nextType = resolvePublicPageType(this.props.match).page_type;
        if (prevType === nextType) {
            return;
        }
        this.loadPage(this.props.match);
    }

    rowItemKey(item, index) {
        return (
            (item &&
                (item.content_item_id ||
                    item.admin_video_id ||
                    item.channel_id ||
                    item.unique_id)) ||
            index
        );
    }

    renderVideoList = (maindata, index) => {
        const pageType =
            this.state.page_type ||
            resolvePublicPageType(this.props.match).page_type;
        const items = Array.isArray(maindata.data) ? maindata.data : [];
        return (
            <React.Fragment key={index}>
                <div className="main-slidersec">
                    <Link
                        to={{
                            pathname: "/view-all",
                            state: {
                                url_type: maindata.url_type,
                                url_type_id: maindata.url_type_id,
                                page_type: pageType,
                                title: maindata.title
                            }
                        }}
                    >
                        <h3 className="">
                            {maindata.title}
                            <i className="fas fa-angle-right ml-2" />
                        </h3>
                    </Link>

                    <Slider>
                        {items.map((movie, i) => (
                            <ContentCard
                                movie={movie}
                                key={this.rowItemKey(movie, i)}
                            />
                        ))}
                    </Slider>
                </div>
            </React.Fragment>
        );
    };

    renderVideoNoData = (maindata, index) => {
        return (
          <React.Fragment key={index}>
          </React.Fragment>
        );
      };

    render() {
        const {
            loading,
            maindata,
            banner,
            loadingHomeSecondSection,
            homeSecondData,
            experience,
        } = this.state;

        const resolved = resolvePublicPageType(this.props.match);
        if (resolved.page_type === "KIDS" && !isKidsSectionEnabled()) {
            return <Redirect to="/home" />;
        }

        const firstRows = Array.isArray(maindata) ? maindata : [];
        const secondRows = Array.isArray(homeSecondData) ? homeSecondData : [];

        const destinationType =
            resolved.page_type === "SERIES"
                ? "series"
                : resolved.page_type === "KIDS"
                ? "kids"
                : "movies";

        return (
            <ExperienceGate
                destinationType={destinationType}
                presentation={experience}
            >
            <div>
                {loading ? (
                    <HomeLoader />
                ) : (
                    <HomePageBanner banner={banner} />
                )}
                <div className="main p-40">
                    {loading
                        ? ""
                        : firstRows.map((mainDa, index) =>
                              !mainDa.data || mainDa.data.length === 0
                                  ? this.renderVideoNoData(mainDa, index)
                                  : loading
                                  ? t("loading")
                                  : this.renderVideoList(mainDa, index)
                          )}

                    {loadingHomeSecondSection
                        ? ""
                        : secondRows.map((mainDa, index) =>
                              !mainDa.data || mainDa.data.length === 0
                                  ? ""
                                  : loading
                                  ? t("loading")
                                  : this.renderVideoList(mainDa, index)
                          )}

                    <div className="height-100" />
                </div>
            </div>
            </ExperienceGate>
        );
    }
}

export default Genres;
